import { Village } from '@/services/types';
import React, { createContext, useContext, ReactNode, useState, HTMLAttributes, useRef } from 'react';

interface GalleryContextData {
  villa?: Village;
  changeVillageInfo: (villa?: Village) => void;
}

export const GalleryContext = createContext<GalleryContextData>(
  {} as GalleryContextData,
);

export const GalleryProvider = ({ children }: { children: ReactNode }) => {
  const [villageInfo, setVillageInfo] = useState<Village>();

  function changeVillageInfo(villa?: Village) {
    setVillageInfo(villa);
  }

  return (
    <GalleryContext.Provider
      value={{
        villa: villageInfo,
        changeVillageInfo
      }}
    >
      {children}
    </GalleryContext.Provider>
  );
};

export function useGallery(): GalleryContextData {
  const context = useContext(GalleryContext);

  if (!context) {
    throw new Error('UseGallery must be used within an UseGalleryProvider');
  }

  return context;
}